'use strict';

angular.module('ClinicApp').directive('appointmentStatusAutoReconciliation', function($q, AppointmentService, OCAppointmentUtil, CurrentUser) {
  return {
    templateUrl: '/views/directives/_appointment-status-auto-reconciliation.html',
    scope: {
      appointment: '=appointmentStatusAutoReconciliation',
      setVerifyUpdateDate: '=',
      onSubmit: '&',
      onSuccess: '=',
      onResetTime: '=',
      unscheduledOptionDisabled: '=',
      appointmentVisited: '=',
    },
    link: function($scope) {
      $scope.userSelected = {};
      $scope.isDentalAppointment = OCAppointmentUtil.isDentalAppointment($scope.appointment);

      $scope.views = {
        VERIFY: 1,
        FOLLOWUP: 2,
      };

      $scope.view = $scope.views.VERIFY;

      $scope.treatments = [
        'New Patient Exam',
        'Cleaning',
        'Other Billable Procedure (e.g. filling, crown, radiograph, etc.)',
        'Free Consultation',
      ];

      // ADA Codes https://www.premera.com/documents/044493.pdf
      const parseADACodes = (ADACodes) => {
        const codeArr = ADACodes.split(', ');
        if (codeArr.includes('D0150')) {
          return $scope.treatments[0];
        }
        if (codeArr.includes('D1110')) {
          return $scope.treatments[1];
        }
        return $scope.treatments[2];
      };

      $scope.autoRecon = $scope.appointment?.ocsMetadata?.reconciliationInfo || null;
      $scope.edited = {
        autoDatetime: null,
        autoTreatment: $scope.autoRecon ? parseADACodes($scope.autoRecon?.treatmentType) : null,
        autoValue: $scope.autoRecon ? $scope.autoRecon?.appointmentValueTotal : null,
      };

      $scope.autoDatetime = moment.utc($scope.autoRecon?.appointmentDatetime) || null;
      $scope.autoTreatment = $scope.autoRecon ? parseADACodes($scope.autoRecon?.treatmentType) : null;
      $scope.autoValue = $scope.autoRecon ? $scope.autoRecon?.appointmentValueTotal : null;

      // Keep track of original data to compare against
      $scope.originalData = {
        autoDatetime: moment.utc($scope.autoRecon?.appointmentDatetime) || null,
        autoTreatment: $scope.autoRecon ? parseADACodes($scope.autoRecon?.treatmentType) : null,
        autoValue: $scope.autoRecon ? $scope.autoRecon?.appointmentValueTotal : null,
      };

      $scope.isEditing = false;

      $scope.toggleEditMode = function() {
        $scope.view = $scope.views.VERIFY;
        $scope.isEditing = !$scope.isEditing;
      };

      $scope.updateData = function(updatedData) {
        // Treatment can't be blank, so no need to check it exists
        if (updatedData.autoDatetime && updatedData.autoValue) {
          $scope.autoDatetime = updatedData.autoDatetime;
          $scope.autoTreatment = updatedData.autoTreatment;
          $scope.autoValue = updatedData.autoValue;
          $scope.toggleEditMode();
        }
      };

      $scope.setReviewButton = function(event, name, value) {
        event.target.blur();
        $scope.userSelected.verify[name] = value;
      };

      $scope.verifyData = function() {
        $scope.view = $scope.views.FOLLOWUP;
      };

      $scope.userSelected.verify = {
        appointmentVisited: true,
        anotherBooked: null,
        feedback: null,
      };

      $scope.formatCurrency = (value) => `$${(value ?? 0).toFixed(2).toString()}`;

      $scope.verify = function(form) {
        if (form.$invalid) {
          return $q.reject();
        }
        const dateMismatch =
          moment.utc($scope.autoDatetime).format()
          !== moment.utc($scope.originalData.autoDatetime).format();
        const valueMismatch = $scope.autoValue !== $scope.originalData.autoValue;
        const treatmentMismatch = $scope.autoTreatment !== $scope.originalData.autoTreatment;
        if (dateMismatch || valueMismatch || treatmentMismatch) {
          OpencareAnalytics.trackForm({
            pageType: OpencareAnalytics.pageTypes.INVOICE_MANAGER,
            pageName: $scope.appointment.provider.clinic.name,
            section: 'Auto Reconciliation Tool',
            name: 'Incorrect OCS Data',
            practiceId: $scope.appointment.provider.clinic.id,
            appointmentId: $scope.appointment.id,
            patientId: $scope.appointment.patient.id,
            userId: CurrentUser.getUserId,
            content: {
              is_real_practice: CurrentUser.isImpersonated().toString(),
              ocsDatetime: dateMismatch
                ? moment.utc($scope.originalData.autoDatetime).format()
                : null,
              editedDatetime: dateMismatch ? moment.utc($scope.autoDatetime).format() : null,
              ocsTreatment: treatmentMismatch ? $scope.originalData.autoTreatment : null,
              editedTreatment: treatmentMismatch ? $scope.autoTreatment : null,
              ocsValue: valueMismatch ? $scope.originalData.autoValue.toString() : null,
              editedValue: valueMismatch ? $scope.autoValue.toString() : null,
            },
          });
        }

        const providerResponse = {
          ...valueMismatch && {
            appointmentValue: $scope.autoValue,
          },
          ...treatmentMismatch && {
            treatmentType: $scope.autoTreatment,
          },
          ...dateMismatch && {
            appointmentDatetime: $scope.autoDatetime.format(),
          },
        };

        return AppointmentService.verifyAppointment($scope.appointment.id, {
          visited: $scope.userSelected.verify.appointmentVisited,
          anotherBooked: $scope.userSelected.verify.anotherAppointmentBooked,
          feedback: $scope.userSelected.verify.feedback,
          ...!_.isEmpty(providerResponse) && {
            providerResponse: providerResponse,
          },
        }).then(function() {
          $scope.onSuccess('Completed');
        });
      };
    },
  };
});
